import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from 'chart.js';
import 'chartjs-adapter-moment';
import { Line } from 'react-chartjs-2';

import { convertResponseToLabel } from './ResponseLabel';

let registered = false;

const CheckInHistoryChart = ({ data }) => {
    if (!registered) {
        ChartJS.register(
            CategoryScale,
            LinearScale,
            TimeScale,
            PointElement,
            LineElement,
            Title,
            Tooltip,
            Legend
        );
        registered = true;
    }

    const options = {
        maintainAspectRatio: false,
        scales: {
            y: {
                min: 1,
                max: 5,
                ticks: {
                    callback: function(
                        value, 
                        // todo - keep these or remove?
                        // eric: you can remove them I guess, though I like keeping them there because then I know what args ARE available without googling
                        // index, 
                        // values
                    ) {
                        if(value !== Math.round(value)) return null;
                        return convertResponseToLabel(value);
                    }
                }
            },
            x: {
                type: 'time',
                time: {
                    unit: 'day'
                }
            }
        },
        plugins: {
            legend: { display: false }
        }
    };

    const chartData = {
        datasets: [{
            label: false,
            data: data,
            borderColor: 'rgba(53,162,235)'
        }]
    };

    return (
        <div style={{height: "200px", position: "relative"}}><Line options={options} data={chartData} /></div>
    );
}

export default CheckInHistoryChart;